import React, { useState } from 'react'
import '../css/general/BottomBar.css'
import { useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Cart from '../components/Cart'

const BottomBar = ({ isUser, isDeliveryAgent }) => {
    const [showCart, setShowCart] = useState(false);
    const [showLogout, setShowLogout] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('userData');
        localStorage.removeItem('cart');
        localStorage.removeItem('isUser', 'true');
        localStorage.removeItem('isDeliveryAgent', 'true');
        navigate('/');
        window.location.reload();
    }

    return (
        <>
            <footer className='bottom-bar-area'>
                <div className='container'>

                    <div className='d-flex justify-content-between'>

                        {isUser && (
                            <>
                                <NavLink activeClassName="active" to='/' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-house"></i>
                                    <p className='my-0'>Home</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/shop' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-store"></i>
                                    <p className='my-0'>Shop</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/order-history' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-clipboard-list"></i>
                                    <p className='my-0'>Order</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/checkout' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-shopping-cart"></i>
                                    <p className='my-0'>Cart</p>
                                </NavLink>

                                <NavLink activeClassName="active" to='/profile' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-circle-user"></i>
                                    <p className='my-0'>Account</p>
                                </NavLink>
                            </>
                        )}


{isDeliveryAgent && (
    <>
                                    <NavLink activeClassName="active" to='/' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-house"></i>
                                    <p className='my-0'>Home</p>
                                </NavLink>
                                <NavLink activeClassName="active" to='/profile' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-circle-user"></i>
                                    <p className='my-0'>Account</p>
                                </NavLink>
                                <NavLink activeClassName="active" to='/order-delivered' className='bottom-bar-text'>
                                    <i class="fa-solid bottom-bar-icon fa-clipboard-list"></i>
                                    <p className='my-0'>Order</p>
                                </NavLink>
    </>
)}

                        <span to='/logout' className='bottom-bar-text cursor-pointer' onClick={() => setShowLogout(true)}>
                            <i class="fa-solid bottom-bar-icon fa-share"></i>
                            <p className='my-0'>Log Out</p>
                        </span>

                    </div>
                    {/* row ends */}

                </div>
            </footer>

            {showCart && <Cart setShowCart={setShowCart} />}

{showLogout && (
    <>
              <section className='delete-dialog px-3' onClick={() => setShowLogout(false)}>
            <div className='bg-white col-lg-4 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>
              <p className='featured-category my-4'>Do you Really want to Log Out?</p>
              <button className='success-btn' onClick={() => handleLogout()}>Yes</button>&nbsp;&nbsp;
              <button className='danger-btn' onClick={() => setShowLogout(false)}>No</button>
            </div>
          </section>

    </>
)}
        </>
    )
}

export default BottomBar
